import { useSlider } from "components/SliderContext";

const SpecialOffersControls = () => {
  const { slideNext, slidePrev } = useSlider();
  return (
    <nav className="special-offers__switch">
      <button className="special-offers__switch-button" onClick={slidePrev}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 2.66663L4.66667 7.99995L10 13.3333" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      </button>
      <button className="special-offers__switch-button" onClick={slideNext}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 2.66663L4.66667 7.99995L10 13.3333" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      </button>
    </nav>
  )
}

export default SpecialOffersControls;
